import { graphql } from '../gql'

export const ALL_LISTINGS_SUB = graphql(`
  subscription AllListings($orderBy: [listing_order_by!], $where: listing_bool_exp) {
    listing(order_by: $orderBy, where: $where) {
      business_name
      island
      created_at
      updated_at
      id
      tier
      live
      this_week_recommended
      is_island_original
      promoted
    }
  }
`)

export const ALL_LISTINGS_WITH_CATEGORIES = graphql(`
  query AllListingsWithCategories {
    listing(order_by: { business_name: asc }) {
      id
      business_name
      live
      listing_category_tags {
        id
        category_tag_id
      }
    }
  }
`)

export const SEARCH_LISTINGS = graphql(`
  query FuzzySearchListings(
    $searchTerm: String!
    $includeNonLive: Boolean
    $limit: Int!
    $orderBy: [fuzzy_listing_order_by!]
  ) {
    fuzzy_search_listings(
      args: { search: $searchTerm, include_non_live: $includeNonLive }
      limit: $limit
      order_by: $orderBy
    ) {
      id
    }
  }
`)

export const LISTING_BY_ID = graphql(`
  query ListingByID($id: Int!) {
    listing_by_pk(id: $id) {
      id
      slug
      business_name
      slogan
      description
      rich_description
      island
      created_at
      updated_at
      tier
      promoted
      live
      primary_address
      primary_phone
      primary_email
      primary_web_url
      this_week_recommended
      is_island_original
      booking_links
      business_hours
      breadcrumbs
      social_media
      promo_code_visitor_hook
      promo_code_count
      images
      videos
      layout_data
      lat_lng
      listing_category_tags {
        id
        category_tag_id
      }
      promo_codes(order_by: { created_at: asc }) {
        id
        code
        label
        expiration
      }
    }
  }
`)

export const LISTINGS_BY_CATEGORY = graphql(`
  query ListingsByCategory($categoryId: Int!) {
    listing(where: { listing_category_tags: { category_tag_id: { _eq: $categoryId } } }) {
      id
      business_name
      listing_category_tags(where: { category_tag_id: { _eq: $categoryId } }) {
        id
      }
    }
  }
`)

export const AD_BY_ID = graphql(`
  query getAdById($id: Int!) {
    ad_by_pk(id: $id) {
      id
      created_at
      name
      link
      image
      size
    }
  }
`)

export const ALL_ADS = graphql(`
  query AllAds($whereClause: ad_bool_exp) {
    ad(where: $whereClause, order_by: { updated_at: desc }) {
      id
      created_at
      updated_at
      name
      link
      image
      size
    }
  }
`)

export const ALL_AD_CYCLES = graphql(`
  query getAdCycles {
    ad {
      id
      name
      image
      link
      size
      ad_cycles(order_by: { starts_at: asc }) {
        id
        starts_at
        ends_at
        loads
      }
    }
  }
`)

export const CYCLE_STATS_BY_ID = graphql(`
  query AdCycleStatsById($id: Int!) {
    ad_cycle_by_pk(id: $id) {
      ad_events_aggregate {
        aggregate {
          variance {
            id
            ad_cycle_id
          }
        }
      }
    }
  }
`)

export const CYCLE_ANALYTICS = graphql(`
  query cycleAnalytics($id: Int!) {
    ad_cycle_by_pk(id: $id) {
      id
      loads
      clicks: ad_events_aggregate(where: { event_type: { _eq: "click" } }) {
        aggregate {
          count
        }
      }
      unique_clicks: ad_events_aggregate(where: { unique: { _eq: true }, event_type: { _eq: "click" } }) {
        aggregate {
          count
        }
      }
      views: ad_events_aggregate(where: { event_type: { _eq: "view" } }) {
        aggregate {
          count
        }
      }
      unique_views: ad_events_aggregate(where: { unique: { _eq: true }, event_type: { _eq: "view" } }) {
        aggregate {
          count
        }
      }
    }
  }
`)

export const GET_CATEGORY_TAGS = graphql(`
  query GetCategoryTags {
    category_tag(order_by: [{ is_primary: desc }, { label: asc }]) {
      id
      label
      is_primary
      listing_category_tags_aggregate {
        aggregate {
          count
        }
      }
    }
  }
`)

export const BREADCRUMBS = graphql(`
  query Breadcrumbs {
    listing(where: { breadcrumbs: { _neq: [] } }) {
      breadcrumbs
    }
  }
`)

export const REGISTRATION_QUESTIONS = graphql(`
  query getRegistrationQuestions {
    visitor_question(order_by: { order: asc }) {
      id
      label
      question_type
      active
      metadata
      order
      visitor_answers_aggregate {
        aggregate {
          count
        }
      }
    }
  }
`)

export const VISITORS = graphql(`
  query Visitors {
    users(order_by: { lastSeen: desc }) {
      id
      email
      displayName
      lastSeen
      defaultRole
    }
  }
`)

export const ALL_ANSWERS = graphql(`
  query AllAnswers {
    visitor_answer {
      id
      question_id
      user_id
      answer
      created_at
    }
  }
`)

export const VISITOR_ANSWERS = graphql(`
  query visitorAnswers {
    visitor_answer {
      id
      question_id
      answer
      created_at
      updated_at
      user_id
    }
  }
`)

export const VISITOR_ANSWERS_BY_USER_ID = graphql(`
  query visitorAnswersByUserId($userId: uuid!) {
    visitor_answer(where: { user_id: { _eq: $userId } }) {
      id
      question_id
      answer
      created_at
      updated_at
      user_id
    }
  }
`)

export const VISITOR_QUESTION_WITH_ANSWERS = graphql(`
  query VisitorQuestionWithAnswers($questionId: Int!) {
    visitor_question_by_pk(id: $questionId) {
      id
      label
      question_type
      active
      metadata
      order
      visitor_answers {
        id
        user_id
        answer
        created_at
      }
    }
  }
`)
